<template>
  <div class="tw-my-6 tw-flex tw-justify-between">
    <div>
      <div class="tw-flex tw-items-center tw-gap-4">
        <div
          v-if="pageMeta.icon"
          :data-test-id="`page-title-solution-icon-prefix`"
          class="tw-mb-3 tw-w-9 tw-h-9 tw-p-0.5 tw-m-0 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-place-self-center"
        >
          <component :is="pageMeta.icon" />
        </div>
        <div class="tw-flex tw-gap-2 tw-items-center">
          <cl-heading size="h3">
            {{ pageMeta.title }}
          </cl-heading>
          <t-page-header-info
            v-if="pageMeta.info"
            :docs-link="pageMeta.info.docsLink"
            :text="pageMeta.info.text"
          />
        </div>
        <cl-pill
          class="tw-mb-3"
          v-if="pageMeta.pill"
          :variant="pageMeta.pill.variant"
        >
          <div class="tw-text-sm">
            {{ pageMeta.pill.text }}
          </div>
        </cl-pill>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from "pinia";
import TPageHeaderInfo from "./TPageHeaderInfo.vue";
import { ProductLink, UserLink } from "./TPageHeader.types";
import { usePageMetaStore } from "@/store/pageMeta.store";

type Props = {
  userLinks: UserLink[];
  productLinks: ProductLink[];
  dataTestId: string;
};

defineProps<Props>();

const { pageMeta } = storeToRefs(usePageMetaStore());
</script>
